export default class StatisticCalculator {
  constructor() {
    this.base100 = false;
  }
}
